const setGenerateFromDocImportStatusAction = ({ commit }, payload) => {
  commit('setGenerateFromDocImportStatus', payload)
}

const setGenerateFromDocImportErrorAction = ({ commit }, payload) => {
  commit('setGenerateFromDocImportError', payload)
}

const setDocToQuizUniqueRequestIdAction = ({ commit }, payload) => {
  commit('setDocToQuizUniqueRequestId', payload)
}

const setDocToQuizResultAction = ({ commit }, payload) => {
  commit('setDocToQuizResult', payload)
}

const setDocToQuizResultModalVisibleAction = ({ commit }, payload) => {
  commit('setDocToQuizResultModalVisible', payload)
}

export default {
  setGenerateFromDocImportStatusAction,
  setGenerateFromDocImportErrorAction,
  setDocToQuizUniqueRequestIdAction,
  setDocToQuizResultAction,
  setDocToQuizResultModalVisibleAction,
}
